import {
	performPostRequest as jiraPerformPostRequest,
	performPutRequest as jiraPerformPutRequest,
	performDeleteRequest as jiraPerformDeleteRequest,
	performGetRequest as jiraPerformGetRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { performIssueRequest } from './request.tsx';

export const performIssuePostRequest = async <T,>(
	url: string,
	options: RequestInit = {},
	path: string,
) => {
	if (fg('issue-view-enable-reliability-wrapper-utils')) {
		return performIssueRequest<T>(jiraPerformPostRequest, url, options, path);
	}

	return jiraPerformPostRequest(url, options);
};

export const performIssuePutRequest = async <T,>(
	url: string,
	options: RequestInit = {},
	path: string,
) => {
	if (fg('issue-view-enable-reliability-wrapper-utils')) {
		return performIssueRequest<T>(jiraPerformPutRequest, url, options, path);
	}

	return jiraPerformPutRequest(url, options);
};

export const performIssueDeleteRequest = async <T,>(
	url: string,
	options: RequestInit = {},
	path: string,
) => {
	if (fg('issue-view-enable-reliability-wrapper-utils')) {
		return performIssueRequest<T>(jiraPerformDeleteRequest, url, options, path);
	}

	return jiraPerformDeleteRequest(url, options);
};

export const performIssueGetRequest = async <T,>(
	url: string,
	options: RequestInit = {},
	path: string,
) => {
	if (fg('issue-view-enable-reliability-wrapper-utils')) {
		return performIssueRequest<T>(jiraPerformGetRequest, url, options, path);
	}

	return jiraPerformGetRequest(url, options);
};
